var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail011(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66797 5.83398L8.47207 10.5969C9.02304 10.9825 9.29853 11.1754 9.59819 11.2501C9.86288 11.3161 10.1397 11.3161 10.4044 11.2501C10.7041 11.1754 10.9796 10.9825 11.5305 10.5969L18.3346 5.83398M5.66797 16.6673H14.3346C15.7348 16.6673 16.4348 16.6673 16.9696 16.3948C17.44 16.1552 17.8225 15.7727 18.0622 15.3023C18.3346 14.7675 18.3346 14.0674 18.3346 12.6673V7.33398C18.3346 5.93385 18.3346 5.23379 18.0622 4.69901C17.8225 4.2286 17.44 3.84615 16.9696 3.60647C16.4348 3.33398 15.7348 3.33398 14.3346 3.33398H5.66797C4.26784 3.33398 3.56777 3.33398 3.03299 3.60647C2.56259 3.84615 2.18014 4.2286 1.94045 4.69901C1.66797 5.23379 1.66797 5.93385 1.66797 7.33398V12.6673C1.66797 14.0674 1.66797 14.7675 1.94045 15.3023C2.18014 15.7727 2.56259 16.1552 3.03299 16.3948C3.56777 16.6673 4.26784 16.6673 5.66797 16.6673Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail011);
export default __webpack_public_path__ + "static/media/mail-01 (1).74c179aa854d2dc43aadd3999e0ca042.svg";
export { ForwardRef as ReactComponent };